module.exports = __webpack_public_path__ + "img/about_300px.c948900b.jpg";